import React from 'react';

// Shimmering "loading" label — a light sweep travels across the text.
// Replaces the old spinner/orb loading indicator. Pure CSS animation
// (keyframe `shimmer-text` lives in design-system.css); no motion lib.
const SHIMMER_STYLE = {
  // Item 3 — blue-tinted slate base (was pure neutral #404040).
  background: 'linear-gradient(110deg, #3c454b 35%, #fff 50%, #3c454b 75%, #3c454b)',
  backgroundSize: '200% 100%',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
  fontSize: 14,
  fontWeight: 400,
  fontFamily: 'var(--font-sans, Inter, sans-serif)',
  animation: 'shimmer-text 2s linear infinite',
};

export function ShiningText({ text = 'Generating', color, style, className }) {
  // Optional `color` prop tints the shimmer base (the sweep highlight stays
  // white) — e.g. the idle-home headline passes the orb's baby blue.
  const shimmerBg = color
    ? `linear-gradient(110deg, ${color} 35%, #fff 50%, ${color} 75%, ${color})`
    : SHIMMER_STYLE.background;
  return <span style={{ ...SHIMMER_STYLE, background: shimmerBg, backgroundSize: '200% 100%', ...style }} className={className}>{text}</span>;
}

export default ShiningText;
